<template>
  <layouts-header />
  <layouts-sidebar />

  <div class="page-wrapper">
    <div class="content">

      <page-header title="Pozitive Uplifts" />

      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body">

              <div class="settings-header d-flex justify-content-between">
                <h4>Pozitive Energy Uplifts</h4>
                <button class="btn btn-sm btn-success" @click="addRow">
                  + Add Uplift
                </button>
              </div>

              <Form @submit.prevent="saveUplifts">
                <div class="settings-form">

                  <table class="table">
                    <thead>
                      <tr>
                        <th>From</th>
                        <th>To</th>
                        <th>Uplift</th>
                        <th>Action</th>
                        <!-- {{ uplifts }} -->
                      </tr>
                    </thead>

                    <tbody>
                      <tr v-for="(row, index) in uplifts" :key="row.id || index" 
                          :class="{ 'table-danger': row.delete }">

                        <td>
                          <input type="number" class="form-control"
                                 v-model="row.from" :disabled="row.delete">
                        </td>

                        <td>
                          <input type="number" class="form-control"
                                 v-model="row.to" :disabled="row.delete">
                        </td>

                        <td>
                          <input type="number" step="0.0001" class="form-control"
                                 v-model="row.uplift" :disabled="row.delete">
                        </td>

                        <td>
                          <button type="button" class="btn btn-danger btn-sm"
                                  @click="deleteRow(index)">
                            {{ row.delete ? 'Undo' : 'Delete' }}
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>

                </div>

                <div class="text-end mt-3">
                  <button type="submit" class="btn btn-primary">
                    Save All Changes
                  </button>
                </div>

              </Form>

            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { ref, onMounted, computed } from "vue";
import { useStore } from "vuex";

export default {
  setup() {
    const store = useStore();

    // Computed getter from Vuex
    const uplifts = computed(() => store.getters['pozitiveUplifts/getUplifts']);

    // Load uplifts from Vuex
    const loadUplifts = async () => {
      const res = await store.dispatch('pozitiveUplifts/fetchUplifts');
      console.log(res, '=========');
      
    };

    // Add a new row
    const addRow = () => {
      store.state.pozitiveUplifts.uplifts.push({
        from: "",
        to: "",
        uplift: "",
        delete: false,
      });
    };

    // Soft-delete row
    const deleteRow = (index) => {
      const row = store.state.pozitiveUplifts.uplifts[index];
      if (row.id) {
        row.delete = !row.delete; // toggle delete
      } else {
        store.state.pozitiveUplifts.uplifts.splice(index, 1); // remove unsaved row
      }
    };

    // Save all uplifts via Vuex action
    const saveUplifts = async () => {
      await store.dispatch('pozitiveUplifts/saveUplifts', store.state.pozitiveUplifts.uplifts);
    };

    onMounted(() => {
      loadUplifts();
    });

    return {
      uplifts,
      addRow,
      deleteRow,
      saveUplifts,
    };
  }
};
</script>
